import { useIndexedDB } from "react-indexed-db-hook";
import { useEffect, useState } from "react";
import { IEmail } from "types/emailPicker.type";

export default function useEmailsState() {
    const dbValues = useIndexedDB("emails");
    const { getAll, add, deleteRecord, getByIndex: _getByIndex, clear: clearAll, getByID } = dbValues;

    const [emails, setEmails] = useState<IEmail[]>([]);

    const reload = () => {
        getAll()
            .then((valuesFromDB) => {
                setEmails(valuesFromDB);
            })
            .catch(() => setEmails([]));
    };

    useEffect(() => {
        reload();
    }, [dbValues]);

    const getByIndex = (indexName: keyof IEmail, key: any) => {
        if (indexName === "id") {
            key = parseInt(key);
        }
        return emails.find((emails) => emails[indexName] === key);
    };

    const deleteByIndex = async (indexName: keyof IEmail, key: any) => {
        if (indexName === "id") {
            await deleteRecord(parseInt(key));
        } else {
            const entity = await _getByIndex(indexName, key);
            await deleteRecord(entity.id);
        }
        reload();
    };

    return { emails, add, deleteRecord, getByIndex, getByIndexAsync: _getByIndex, deleteByIndex, clearAll, reload };
}
